/* Actions */
export const GET_TYPES_REQUEST = "GET_TYPES_REQUEST";
export const POPULATE_TYPES_LIST = "POPULATE_TYPES_LIST";

/* Mutations */
export const POPULATE_TYPES_LIST_SUCCESS = "POPULATE_TYPES_LIST_SUCCESS";
export const SET_POPULATING_TYPES_LIST_VALUE =
  "SET_POPULATING_TYPES_LIST_VALUE";
